import {ISSECURITYINFO} from '../constact'

const isSecurityInfoInit = false;
export default function isLogin(preState = isSecurityInfoInit, action) {
    const {type, data} = action;
    switch (type) {
        case ISSECURITYINFO:
            return data;
        default:
            return preState;
    }
}